var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"info-button"},[_c('Tooltip',{attrs:{"message":_vm.message,"pinnable":true}},[_c('MaterialDesignIcon',{staticClass:"icon",attrs:{"icon":_vm.mdiAlertCircle}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }